import { tap, ignoreElements, filter } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import {
  getHasPackagesError,
  getOperationCode,
  getProductSourceKey,
  getProductTitle
} from 'store/selectors'
import { disableMixPanelTracking } from '../disable'

const mapStateToMPEvent = (eventName, state) => ({
  'Error Name': 'Package Not Set',
  'Event Name': eventName,
  'Interaction Type': 'Page View',
  'Operation Code': getOperationCode(state),
  'Page Name': 'Product Page',
  'Product': getProductTitle(state),
  'Product ID': getProductSourceKey(state)
})

const technicalErrorNoPackageEpic = (
  actions$,
  state$
) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(Actions.resources.RESOURCE_FETCHED),
  filter(action => action.payload.type === 'product'),
  tap(() => {
    const state = state$.value

    if (getHasPackagesError(state)) {
      const eventName = 'Technical Error'

      track(eventName, mapStateToMPEvent(eventName, state), { debug: !__PRODUCTION__ })
    }
  }),
  ignoreElements()
)

export default technicalErrorNoPackageEpic
